<template>
  <div class="banner">
    <div v-if="bannerDivider == 'first'">
      <img src="@/assets/images/banners/rays_divider01.jpg" />
    </div>
    <div v-if="bannerDivider == 'second'">
      <img src="@/assets/images/banners/rays_divider02.jpg" />
    </div>
    <div v-if="bannerDivider == 'third'">
      <img src="@/assets/images/banners/rays_divider03.jpg" />
    </div>
    <div v-if="bannerDivider == 'forth'">
      <img src="@/assets/images/banners/rays_divider04.jpg" />
    </div>
    <div v-if="bannerDivider == 'fifth'">
      <img src="@/assets/images/banners/rays_divider05.jpg" />
    </div>
    <div v-if="bannerDivider == 'sixth'">
      <img src="@/assets/images/banners/rays_divider06.jpg" />
    </div>
    <div v-if="bannerDivider == 'seventh'">
      <img src="@/assets/images/banners/rays_divider07.jpg" />
    </div>
    <div v-if="bannerDivider == 'eighth'">
      <img src="@/assets/images/banners/rays_divider08.jpg" />
    </div>
    <div v-if="bannerDivider == 'ninth'">
      <img src="@/assets/images/banners/rays_divider09.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["bannerDivider"],
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  /* margin: 100px 0; */
  @media only screen and (max-width: $sm) {
    /* margin: 50px 0; */
  }
  img {
    width: 100%;
  }
}
</style>
